import { Injectable, ErrorHandler, Injector } from '@angular/core';
import * as StackTrace from 'stacktrace-js';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
@Injectable( {
    providedIn: 'root'
} )
export class GlobalErrorHandlerService implements ErrorHandler {
    // https://plnkr.co/edit/jCxvLrc1FFGUqYJDqA3q?p=preview
    constructor( private injector: Injector ) {
    }
    handleError ( error ) {
        const location = this.injector.get( LocationStrategy );
        const message = error.message ? error.message : error.toString();
        const url = location instanceof PathLocationStrategy ? location.path() : '';
        // get the stack trace, lets grab the last 10 stacks only
        // let stackString = '';
        // StackTrace.fromError( error ).then( stackframes => {
        //     const stackString = stackframes
        //         .splice( 0, 20 )
        //         .map( function ( sf ) {
        //             return sf.toString();
        //         } ).join( '\n' );
        //     console.log( 'Error [message, url, stack]:', [ message, url, stackString ] );
        // } );


        StackTrace.fromError( error )
            .then( console.log );

        StackTrace.get()
            .then( function ( stack ) {
                console.log( 'Error [message, url, stack]:', [ message, url, stack ] );
            } )
            .catch( function ( err ) {
                console.log( 'Got err:', err );
            } );



        // IMPORTANT: Rethrow the error otherwise it gets swallowed (trying disabling for cleaner log)
        // throw error;
        // super.handleError( error );
    }
}
